"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _find = _interopRequireDefault(require("lodash/find"));
var _Vector = _interopRequireDefault(require("ol/layer/Vector.js"));
var _Feature = _interopRequireDefault(require("ol/Feature.js"));
var _Point = _interopRequireDefault(require("ol/geom/Point.js"));
var _Projection = _interopRequireDefault(require("ol/proj/Projection.js"));
var _proj = require("ol/proj");
var _Vector2 = _interopRequireDefault(require("ol/source/Vector.js"));
var _Style = _interopRequireDefault(require("ol/style/Style.js"));
var _Icon = _interopRequireDefault(require("ol/style/Icon.js"));
var _map = require("../map");
var _equipment = _interopRequireDefault(require("../../../../assets/icons/equipment.png"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// import ol from "openlayers";

// import { Feature, VectorLayer } from 'ol';

var layer = new _Vector["default"]({
  visible: false,
  name: "equipment"
});

// Init layer
_map.map.addLayer(layer);

// Init stream subscriptions
var equipment = {
  handleUpdate: function handleUpdate(_ref) {
    var layers = _ref.layers,
      equipment = _ref.equipment;
    layer.setVisible(layers === null || layers === void 0 ? void 0 : layers.equipment);

    //early cutoff for when layer is not visible or unavailable
    if (!(layers !== null && layers !== void 0 && layers.equipment) || !equipment) return;

    // Otherwise, update locations
    var features = equipment.filter(function (equipment) {
      return equipment.latLong[0] || equipment.latLong[1];
    }) // Filter out trains without a location
    .map(function (item) {
      // set properties & style
      var feature = new _Feature["default"]({
        geometry: new _Point["default"]((0, _proj.transform)([item.latLong[1], item.latLong[0]], "EPSG:4326", "EPSG:900913")),
        name: "".concat(item.equipment.description, " - ").concat(item.equipment.manufacturer, " (").concat(item.equipment.model, ")")
      });
      feature.setProperties(item);
      feature.setStyle(equipmentIconStyle);
      feature.setProperties(item);
      return feature;
    });

    // set the features to this layer
    layer.setSource(new _Vector2["default"]({
      features: features
    }));
  },
  getOverlay: function getOverlay(equipmentId, equipment) {
    // Set overlay position
    var item = (0, _find["default"])(equipment, function (e) {
      return e.equipment.equipmentId == equipmentId;
    });

    // cutoff for no train found
    if (!item) {
      return null;
    }

    // set position
    _map.overlay.setPosition((0, _proj.transform)([item.latLong[1], item.latLong[0]], "EPSG:4326", "EPSG:900913"));
    _map.overlay.setProperties({
      layer: "equipment",
      equipmentId: item.equipment.equipmentId
    });
    // output rendered content
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "overlay-content basic"
    }, "".concat(item.equipment.description, " - ").concat(item.equipment.manufacturer, " (").concat(item.equipment.model, ")"));
  }
};
var _default = equipment; // Styles
exports["default"] = _default;
var equipmentIconStyle = new _Style["default"]({
  image: new _Icon["default"]({
    anchor: [0.5, 0.5],
    anchorXUnits: 'fraction',
    anchorYUnits: 'fraction',
    opacity: 1,
    src: _equipment["default"]
  })
});